import { CognitoUserInterface } from 'libs/shared/types/src/lib';
import { Dispatch, SetStateAction } from 'react';
import { CONSTANTS } from '@investigator/shared/constants';
import { UserRole } from '@investigator/shared/providers';

interface SetRoleProps {
  user: CognitoUserInterface;
  setUserRole: Dispatch<SetStateAction<UserRole>>;
}

export const setRole = ({ user, setUserRole }: SetRoleProps) => {
  const cognitoGroups =
    user?.signInUserSession?.accessToken?.payload['cognito:groups'];

  setUserRole(
    cognitoGroups?.includes(CONSTANTS.ROLE.admin)
      ? 'admin'
      : cognitoGroups?.includes(CONSTANTS.ROLE.analyst)
        ? 'analyst'
        : cognitoGroups?.includes(CONSTANTS.ROLE.viewer)
          ? 'viewer'
          : undefined,
  );
};
